<template>
  <a-form-item
    :label="data.fieldname"
    class="cascader-group"
  >
    <div class="form-item-value">
      <my-checkbox
        v-if="data.fieldkey === 'follow_userid' && followCheckOptions.length"
        :data="{ options: followCheckOptions, fieldvalue: follow_status }"
        @change="handleCheckboxFollow"
      />
      <a-checkbox
        v-if="data.fieldkey === 'input_userid'"
        :checked="!!is_universal_form"
        @change="handleCheckboxInput"
      >
        {{ $t('message["1728"]') }}
      </a-checkbox>
      <div
        v-for="(item, index) in list"
        :key="item._id"
        class="item"
      >
        <!-- 或 -->
        <span
          v-if="index > 0 || (item.fieldkey === 'follow_userid' && followCheckOptions.length) || (item.fieldkey === 'input_userid')"
          class="left-text"
        >{{ $t('message["451"]') }}</span>
        <from-cascader
          v-if="item.fieldkey === 'from_info' || item.fieldtype === 'select_reception'"
          :value="item.value"
          :data="item"
          :index="index"
          :placeholder="item.placeholder"
          @change="handleChange"
        />
        <my-cascader
          v-else
          :value="item.value"
          :get-data="getData"
          :data="item"
          :placeholder="item.placeholder"
          @change="handleChange"
        />
        <i
          class="iconfont iconicon-test8 fs-gray del-btn"
          @click="handelDelete(item, index)"
        />
      </div>
      <div class="btns">
        <span class="left-text">{{ $t('message["451"]') }}</span>
        <a-button
          class="btn-text add-btn"
          @click="handelAdd"
        >
          <i class="iconfont iconicon-test10" />
          {{ $t('message["1561"]') }}
        </a-button>
      </div>
    </div>
  </a-form-item>
</template>

<script>
import { mapState } from 'vuex'
import MyCascader from './Cascader'
import FromCascader from './FromCascader'
import MyCheckbox from './../formItem/CheckBox'

export default {
  components: {
    MyCascader,
    FromCascader,
    MyCheckbox
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    getData: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      newData: {},
      list: [],
      value: [],
      follow_userid: [],
      follow_status: [],
      is_universal_form: 0,
      input_userid: []
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    },
    followCheckOptions () {
      let { options = [] } = this.data || {}
      options = options.filter(item => (item.id === 3 && this.enableshare) || item.id !== 3)
      return options || []
    }
  },
  watch: {
    data: {
      handler (val) {
        if (val) {
          this.data.info = {}
          this.list = []
          this.value = []
          this.setDefault(this.data)
        }
      },
      // deep: true,
      immediate: true
    }
  },
  created () {
    this.newData = JSON.parse(JSON.stringify(this.data))
  },
  methods: {
    setDefault (data) {
      if (data.fieldkey === 'follow_userid' || data.fieldkey === 'input_userid') {
        // fieldvalue是对象
        this.setFollowInputDefault(data)
      } else { // fieldvalue 是数组
        if (data.fieldvalue && data.fieldvalue.length) {
          this.list = []
          for (let i in data.fieldvalue) {
            const item = data.fieldvalue[i] || []
            let newData = JSON.parse(JSON.stringify(this.data))
            newData._id = Math.random()

            if (data.fieldkey === 'from_info' || data.fieldtype === 'select_reception') {
              newData.value = item || []
            } else {
              newData.info = item || {}
            }
            this.list.push(newData)
          }
        } else if (!this.list.length) {
          let newData = JSON.parse(JSON.stringify(this.data))
          newData._id = Math.random()
          newData.fieldvalue = []
          this.list.push(newData)
        }
      }
      this.$forceUpdate()
    },
    setFollowInputDefault (data) {
      const { fieldvalue = {} } = data || {}

      const {
        follow_status: followStatus,
        follow_userid: followUserid,
        input_userid: inputUserid,
        is_universal_form: isUniversalForm
      } = fieldvalue

      this.follow_status = followStatus
      this.follow_userid = followUserid
      this.is_universal_form = !!isUniversalForm
      this.input_userid = inputUserid

      let useridList = followUserid || inputUserid
      if (useridList && useridList.length) {
        this.list = []
        for (let i in useridList) {
          const item = useridList[i]
          let newData = JSON.parse(JSON.stringify(this.data))
          newData.info = item
          newData._id = Math.random()
          this.list.push(newData)
        }
      } else if (!this.list.length) {
        let newData = JSON.parse(JSON.stringify(this.data))
        newData.fieldvalue = []
        newData._id = Math.random()
        this.list.push(newData)
      }
    },
    handelAdd () {
      let newData = JSON.parse(JSON.stringify(this.data))
      newData.fieldvalue = []
      newData.info = {}
      newData._id = Math.random()
      this.list.push(newData)
    },
    handelDelete (item, index) {
      if (this.list.length === 1) return

      const { fieldkey, fieldtype } = item
      this.list.splice(index, 1)
      if (fieldkey === 'follow_userid') {
        this.follow_userid = this.list.map(item => item.info)
        this.value = (Array.isArray(this.value) || !this.value) ? {} : this.value
        this.value = this.setFollowValue(this.value)
      } else if (fieldkey === 'input_userid') {
        this.input_userid = this.list.map(item => item.info)
        this.value = {}
        this.value['is_universal_form'] = this.is_universal_form ? 1 : 0
        this.value['input_userid'] = this.input_userid
      } else if (fieldkey === 'from_info' || fieldtype === 'select_reception') {
        this.value = this.list.map(item => item.value)
      } else {
        this.value = this.list.map(item => item.info)
      }
      this.$emit('change', this.value)
    },

    handleChange (data) {
      const { fieldtype, fieldkey } = data
      this.value = {}
      switch (fieldtype) {
        case 'selectuser':
        case 'selectfollowuser':
        case 'selectinputuser':
        case 'selectrolegroup':
          if (fieldkey === 'follow_userid') {
            this.follow_userid = this.list.map(item => item.info)
            this.follow_status = this.follow_status || []
            this.value = this.setFollowValue()
          } else if (fieldkey === 'input_userid') {
            this.input_userid = this.list.map(item => item.info)
            this.value = {}
            this.value['input_userid'] = this.input_userid
            this.value['is_universal_form'] = this.is_universal_form ? 1 : 0
          } else {
            this.value = this.list.map(item => item.info)
          }
          break
        case 'from_info':
        case 'select_reception':
          this.value = this.list.map(item => item.value)
          break
      }

      this.$emit('change', this.value)
    },
    setFollowValue (d = {}) {
      let data = d
      data['follow_status'] = this.follow_status || []
      data['follow_userid'] = this.follow_userid || []
      return data
    },
    handleCheckboxFollow (val) {
      this.follow_status = val
      this.value = this.setFollowValue()
      this.$emit('change', this.value)
    },
    handleCheckboxInput (e) {
      this.is_universal_form = e.target.checked
      this.value = {}
      this.value['is_universal_form'] = this.is_universal_form ? 1 : 0
      this.value['input_userid'] = this.input_userid || []
      this.$emit('change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.cascader-group::v-deep .form-item-value {
  .ant-form-item-label {
    display: none;
  }
  .ant-form-item-control-wrapper {
    padding-left: 0;
  }
}
.cascader-group .item {
  position: relative;
  width: 320px;
}
.left-text {
  position: absolute;
  top: 0;
  left: -32px;
}
.del-btn {
  position: absolute;
  top: 0;
  right: -32px;
}
.btns {
  position: relative;
}
.add-btn {
  color: $gray1;
  .iconfont {
    margin-right: 4px;
    color: $gray3;
  }
}
</style>
